import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { ProductType } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  options?: Omit<
    UseMutationOptions<unknown, Error, { id: number }, ProductType>,
    'mutationKey' | 'mutationFn'
  >;
}

export const useDeleteProductTypeRequest = ({ options }: RequestParams = {}) => {
  const api = useApiInstance()

  return useMutation<unknown, Error, { id: number }, ProductType>(
    [Entities.ProductTypes, 'delete'],
    async ({ id }) => {
      const { data } = await api.v1AdminProductsTypesProductTypeIdDelete(id)
      return data
    },
    { ...options },
  )
}
